/**
 * mc-cart.js — Cart drawer interaction logic (v7 — optimistic delete + instant swap).
 */
(function () {
  'use strict';
  if (window.__mcCartDrawerBound) return;
  window.__mcCartDrawerBound = true;

  function getSectionId() {
    var root = document.querySelector('[data-mc-cart-root]');
    return root ? root.getAttribute('data-section-id') : '';
  }

  var ROOT_SELECTOR = '[data-mc-cart-root]';
  var busyLines = Object.create(null);
  var busy = false;

  function getDrawer() { return document.querySelector('cart-drawer-component'); }
  function getDialog() { return document.querySelector('cart-drawer-component dialog.cart-drawer__dialog'); }
  function isDrawerOpen() {
    var d = getDialog();
    return !!(d && d.hasAttribute('open'));
  }

  function markDialogAnimated() {
    var d = getDialog();
    if (d) d.setAttribute('data-mc-opened', '');
  }
  function unmarkDialogAnimated() {
    var d = getDialog();
    if (d) d.removeAttribute('data-mc-opened');
  }
  function bindDialogAnimationWatcher() {
    var d = getDialog();
    if (!d || d.__mcAnimBound) return;
    d.__mcAnimBound = true;
    d.addEventListener('animationend', function (ev) {
      if (ev.target === d) markDialogAnimated();
    });
    var mo = new MutationObserver(function () {
      if (!d.hasAttribute('open')) unmarkDialogAnimated();
    });
    mo.observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  bindDialogAnimationWatcher();

  function openDrawer() {
    if (isDrawerOpen()) return;
    bindDialogAnimationWatcher();
    var drawer = getDrawer();
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) {}
    }
    var d = getDialog();
    if (d && typeof d.showModal === 'function') {
      try { d.showModal(); } catch (e) {}
    }
  }
  window.mcOpenCartDrawer = openDrawer;

  function extractCartCount(html) {
    if (html) {
      var match = html.match(/mc-cart-count[^>]*>(\d+)</);
      if (match) return parseInt(match[1], 10);
    }
    var el = document.querySelector('[data-mc-cart-root] .mc-cart-count');
    if (el) return parseInt(el.textContent, 10);
    return null;
  }

  function showCartBubble(show) {
    document.querySelectorAll('.cart-bubble').forEach(function(c) {
      if (show) {
        c.removeAttribute('hidden');
        c.classList.remove('visually-hidden');
      } else {
        c.classList.add('visually-hidden');
      }
    });
  }

  /**
   * Instant content replacement — no crossfade, just swap.
   */
  function applyCartHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(ROOT_SELECTOR);
    var current = document.querySelector(ROOT_SELECTOR);
    if (fresh && current) {
      markDialogAnimated();
      current.innerHTML = fresh.innerHTML;
      return true;
    }
    return false;
  }

  function updateCartBubble(count) {
    if (count === null || count === undefined) return;
    document.querySelectorAll('.cart-bubble__text').forEach(function(b) { b.textContent = count; });
    showCartBubble(count > 0);
  }

  /* ============================================================
     ADD TO CART — Single request with sections (FAST PATH)
     ============================================================ */
  async function fastAddToCart(formData) {
    var sid = getSectionId();
    var body = {
      items: [{
        id: parseInt(formData.get('id'), 10),
        quantity: parseInt(formData.get('quantity') || '1', 10)
      }],
      sections: sid,
      sections_url: window.location.pathname
    };

    var props = {};
    for (var pair of formData.entries()) {
      if (pair[0].startsWith('properties[')) {
        var key = pair[0].replace('properties[', '').replace(']', '');
        props[key] = pair[1];
      }
    }
    if (Object.keys(props).length > 0) body.items[0].properties = props;

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      if (!res.ok) {
        var errData = await res.json().catch(function() { return {}; });
        console.error('[mc-cart] add failed', errData);
        return false;
      }
      var data = await res.json();
      var sectionHtml = data && data.sections && data.sections[sid];
      if (sectionHtml) {
        var count = extractCartCount(sectionHtml);
        applyCartHtml(sectionHtml);
        if (count !== null) updateCartBubble(count);
      }
      document.dispatchEvent(new CustomEvent('mc-cart:updated'));
      return true;
    } catch (err) {
      console.error('[mc-cart] add failed', err);
      return false;
    }
  }

  // Intercept add-to-cart form submissions
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;
    if (!form.querySelector('[name="id"]')) return;

    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('[type="submit"], button[name="add"]');
    if (btn) {
      var atcComp = btn.closest('add-to-cart-component');
      if (atcComp) atcComp.classList.add('atc-added');
      setTimeout(function() { if (atcComp) atcComp.classList.remove('atc-added'); }, 2000);
    }

    document.querySelectorAll('.cart-bubble__text').forEach(function(b) {
      b.textContent = (parseInt(b.textContent, 10) || 0) + 1;
    });
    showCartBubble(true);

    openDrawer();
    fastAddToCart(new FormData(form));
  }, true);

  /* ============================================================
     CHANGE LINE
     ============================================================ */
  async function changeLine(line, qty, row) {
    if (busyLines[line]) return;
    busyLines[line] = true;
    try {
      var sid = getSectionId();
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: qty, sections: sid, sections_url: window.location.pathname })
      });
      var data = await res.json();
      var sectionHtml = data && data.sections && data.sections[sid];
      if (sectionHtml) {
        var count = extractCartCount(sectionHtml);
        applyCartHtml(sectionHtml);
        if (count !== null) updateCartBubble(count);
      }
      if (data && typeof data.item_count !== 'undefined') updateCartBubble(data.item_count);
      document.dispatchEvent(new CustomEvent('mc-cart:updated'));
    } catch (err) {
      console.error('[mc-cart] change failed', err);
    } finally {
      delete busyLines[line];
    }
  }

  var pendingTimers = Object.create(null);
  var pendingQty = Object.create(null);
  var pendingRow = Object.create(null);

  function queueLineChange(line, qty, row) {
    pendingQty[line] = qty;
    pendingRow[line] = row;
    if (pendingTimers[line]) clearTimeout(pendingTimers[line]);
    pendingTimers[line] = setTimeout(function () {
      var q = pendingQty[line]; var r = pendingRow[line];
      delete pendingTimers[line]; delete pendingQty[line]; delete pendingRow[line];
      changeLine(line, q, r);
    }, 60);
  }

  document.addEventListener('click', function (e) {
    var qBtn = e.target.closest('.mc-qty-btn');
    if (qBtn) {
      e.preventDefault(); e.stopPropagation();
      var row = qBtn.closest('.mc-cart-item');
      var wrapper = qBtn.closest('.mc-cart-item__qty');
      if (!row || !wrapper) return;
      var line = parseInt(wrapper.getAttribute('data-line'), 10);
      var input = wrapper.querySelector('.mc-qty-input');
      var qty = input ? (parseInt(input.value, 10) || 0) : 0;
      qty = qBtn.getAttribute('data-action') === 'inc' ? qty + 1 : Math.max(0, qty - 1);
      if (input) input.value = qty;

      // Optimistic: if quantity becomes 0, animate item out
      if (qty === 0 && row) {
        row.style.height = row.offsetHeight + 'px';
        row.style.overflow = 'hidden';
        requestAnimationFrame(function() {
          row.style.transition = 'height 0.2s ease, opacity 0.15s ease';
          row.style.opacity = '0';
          row.style.height = '0';
          row.style.padding = '0';
          row.style.margin = '0';
          row.style.borderWidth = '0';
        });
        document.querySelectorAll('.cart-bubble__text, .cart-badge, .mc-cart-count').forEach(function(el) {
          var n = parseInt(el.textContent, 10) || 0;
          if (n > 0) el.textContent = n - 1;
        });
      }

      queueLineChange(line, qty, row);
      return;
    }

    var rBtn = e.target.closest('[data-action="remove"]');
    if (rBtn) {
      e.preventDefault(); e.stopPropagation();
      var row2 = rBtn.closest('.mc-cart-item');
      var line2 = parseInt(rBtn.getAttribute('data-line'), 10);
      if (!isNaN(line2)) {
        // Optimistic: animate item out immediately
        if (row2) {
          row2.style.height = row2.offsetHeight + 'px';
          row2.style.overflow = 'hidden';
          requestAnimationFrame(function() {
            row2.style.transition = 'height 0.2s ease, opacity 0.15s ease';
            row2.style.opacity = '0';
            row2.style.height = '0';
            row2.style.padding = '0';
            row2.style.margin = '0';
            row2.style.borderWidth = '0';
          });
        }
        document.querySelectorAll('.cart-bubble__text, .cart-badge, .mc-cart-count').forEach(function(el) {
          var n = parseInt(el.textContent, 10) || 0;
          if (n > 0) el.textContent = n - 1;
        });
        queueLineChange(line2, 0, row2);
      }
    }
  });

  /* ============================================================
     FALLBACK REFRESH
     ============================================================ */
  async function refreshDrawerInPlace() {
    if (busy) return;
    busy = true;
    try {
      var sid = getSectionId();
      var res = await fetch('/cart.js?sections=' + encodeURIComponent(sid), { cache: 'no-store', headers: { 'Accept': 'application/json' } });
      var data = await res.json();
      var sectionHtml = data && data.sections && data.sections[sid];
      if (sectionHtml) {
        var count = extractCartCount(sectionHtml);
        applyCartHtml(sectionHtml);
        if (count !== null) updateCartBubble(count);
      }
      if (data && typeof data.item_count !== 'undefined') updateCartBubble(data.item_count);
      document.dispatchEvent(new CustomEvent('mc-cart:updated'));
    } catch (e) {
      console.error('[mc-cart] refresh failed', e);
    } finally { busy = false; }
  }

  document.addEventListener('cart:add', function() { openDrawer(); refreshDrawerInPlace(); });
  document.addEventListener('cart-add', function() { openDrawer(); refreshDrawerInPlace(); });
})();
